import {TokenCredentials} from '../login/tokencredentials';

export class Stock {
    credentials: TokenCredentials;
    id : number;
	userid : number;
    
    binid : number;
    binLocation: string;

    articleid: number;
    articleNumber: string;
    articleDescr1: string;
    articleDescr2: string;
    articleBaseUnit: string;

    quantity: number;
    quantityFree: number;
    reservationCode: string;
    
    receiptId: number;
    receiptPosId: number;

    created : Date;
    updated : Date;
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/stock/stock.ts